import { redirect } from '@tanstack/react-router'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { Role } from '#shared/model'
import shouldBeLoggedIn from './should-be-logged-in'

export default async function shouldMatchRole(...acceptedRoles: Role[]) {
  const { role } = getCurrentUserRoleInfo()

  if (role === 'unknown') {
    await shouldBeLoggedIn()
    return
  }

  if (!acceptedRoles.includes(role as any)) {
    if (role === 'manager') {
      throw redirect({ to: '/support' })
    }

    throw redirect({ to: '/' + role })
  }
}
